import React from "react"

function AlignBottom({ size }) {
    return (
        <svg viewBox="0 0 24 24" height={size}><path d="M22 22H2v-2h20v2zM10 2H7v16h3V2zm7 6h-3v10h3V8z"></path></svg>
    )
}

export default AlignBottom